import { ReactNode } from 'react'
import { NavLink, Link } from 'react-router-dom'

interface Props {
  children: ReactNode
  active: 'home' | 'why' | 'how'
  showBottomNav?: boolean
  plain?: boolean
}

function LogoMark() {
  return (
    <img className="v2-logo-mark" src="/logo.png" alt="" decoding="async" />
  )
}

const NAV_ITEMS: Array<
  | { key: Props['active']; to: string; label: string }
  | { key: Props['active']; href: string; label: string }
> = [
  { key: 'home',    to: '/',         label: 'Home' },
  { key: 'how',     href: '/#how',   label: 'How' },
]

/**
 * Shared chrome for every v2 page:
 *   - animated stage lights (halation)
 *   - bottom-center nav
 * Film grain + edge vignette come from body::before / body::after in CSS.
 */
export default function StageLayout({ children, active, showBottomNav = true, plain = false }: Props) {
  return (
    <>
      <div className="v2-stage-lights" aria-hidden="true" />

      <Link to="/" className="v2-logo-link" aria-label="ShimmerTech — Home">
        <LogoMark />
      </Link>

      <main className={`v2-stage${plain ? ' v2-stage-plain' : ''}`}>{children}</main>

      {showBottomNav && (
        <nav className="v2-bottom-nav" aria-label="Primary">
          {NAV_ITEMS.map((item) =>
            'href' in item ? (
              <a
                key={item.key}
                href={item.href}
                className={item.key === active ? 'active' : undefined}
              >
                {item.label}
              </a>
            ) : (
              <NavLink
                key={item.key}
                to={item.to}
                className={item.key === active ? 'active' : undefined}
              >
                {item.label}
              </NavLink>
            ),
          )}
        </nav>
      )}
    </>
  )
}
